<app-documents-word-matter-viewer [documentId]="drawerData.docMeta.id">
</app-documents-word-matter-viewer>
